module.exports = require("word-aligner");